module.exports = __webpack_public_path__ + "static/assets/4869b28086efa35ae93eb7c8bd2a3580.png";